import React from 'react';
import { IStudy, IStudyHistory } from 'api-paths-cas';
import { formatAddress } from '../../helpers';
import { CustomCollapse } from '@/components/CustomCollapse/CustomCollapse';
import Field from '@/components/Field/Field';
import { Qualifications } from './Qualifications';
import { getUniqueKeysFromObjects } from '../helpers/findUniqueIds';

export interface IPreviousStudiesProps {
  studyHistoryCurrent?: IStudyHistory;
  studyHistoryInitial?: IStudyHistory;
}

export function PreviousStudies(props: IPreviousStudiesProps): React.ReactElement {
  const { studyHistoryCurrent, studyHistoryInitial } = props;
  const ids = getUniqueKeysFromObjects(studyHistoryCurrent?.previous ?? {}, studyHistoryInitial?.previous ?? {});

  const previousStudyComponents: React.ReactElement[] = [];

  for (const [index, id] of ids.entries()) {
    const studyCurrent: IStudy | undefined = studyHistoryCurrent?.previous?.[id];
    const studyInitial: IStudy | undefined = studyHistoryInitial?.previous?.[id];

    previousStudyComponents.push(
      <PreviousStudy key={`${id}-${index}`} id={id} studyCurrent={studyCurrent} studyInitial={studyInitial} />,
    );
  }

  return <>{previousStudyComponents}</>;
}

export interface IPreviousStudyProps {
  id: string;
  studyCurrent?: IStudy;
  studyInitial?: IStudy;
}

export function PreviousStudy(props: IPreviousStudyProps): React.ReactElement {
  const { id, studyCurrent, studyInitial } = props;

  const header = studyCurrent?.institutionName || studyInitial?.institutionName || 'Unknown institution';

  const institutionName1 = studyCurrent?.institutionName;
  const institutionName2 = studyInitial?.institutionName;

  const country1 = studyCurrent?.country;
  const country2 = studyInitial?.country;

  const address1 = formatAddress({
    ...(studyCurrent?.institutionAddress ?? {}),
    country: studyCurrent?.country,
  });

  const address2 = formatAddress({
    ...(studyInitial?.institutionAddress ?? {}),
    country: studyInitial?.country,
  });

  return (
    <CustomCollapse defaultIsOpen key={`${id}-previous-study`}>
      {/* Step 1: Institution (top level) - School or University name */}
      <CustomCollapse.Trigger>{header}</CustomCollapse.Trigger>
      <CustomCollapse.Content>
        <Field leftLabel="Country" value={country1} originalValue={country2} />
        <Field leftLabel="Institution" value={institutionName1} originalValue={institutionName2} />
        <Field leftLabel="Address" value={address1} originalValue={address2} />

        <Qualifications studyCurrent={studyCurrent} studyInitial={studyInitial} />
      </CustomCollapse.Content>
    </CustomCollapse>
  );
}
